const DAY=864e5;
const U=v=>String(v||'').toUpperCase();

function time(v){const t=+new Date(v||0);return Number.isFinite(t)&&t>0?t:null}
function day(v){const t=time(v);return t==null?null:new Date(t).toISOString().slice(0,10)}

export function deriveOfficialRateCalendar(rows=[],now=new Date()){
 const nowMs=+new Date(now);
 if(!Number.isFinite(nowMs))return[];
 const byRegion=new Map();
 for(const row of Array.isArray(rows)?rows:[]){
  if(U(row?.source_type)!=='OFFICIAL_RATE'||U(row?.verification_status)!=='VERIFIED'||U(row?.ingestion_mode)!=='LIVE_PROVIDER')continue;
  const observed=time(row?.observed_at),meeting=time(row?.next_meeting_at);
  if(observed==null||meeting==null||observed>nowMs+5*60e3)continue;
  const ageDays=(nowMs-observed)/DAY;
  if(ageDays>7)continue;
  const region=U(row?.region_key);
  if(!region)continue;
  const prev=byRegion.get(region);
  if(!prev||time(prev.observed_at)<observed)byRegion.set(region,row);
 }
 const today=new Date(nowMs).toISOString().slice(0,10);
 return[...byRegion.values()].map(row=>{
  const meetingDay=day(row.next_meeting_at);
  if(!meetingDay||meetingDay<today)return null;
  const bank=row.central_bank||row.source_name||row.region_key;
  return{
   id:`official-rate-meeting:${row.region_key}:${meetingDay}`,
   event_key:`official-rate-meeting:${row.region_key}:${meetingDay}`,
   ticker:null,
   event_type:'POLICY_RATE_MEETING',
   title:`${bank} policy decision`,
   scheduled_at:`${meetingDay}T00:00:00.000Z`,
   schedule_precision:'DATE_ONLY',
   impact_level:'POLICY_RATE',
   source_type:'OFFICIAL_RATE_CALENDAR',
   source_name:row.source_name||bank,
   source_ref:row.source_ref||null,
   verification_status:'VERIFIED',
   provider_key:row.source_name||bank,
   notes:`Current policy rate ${row.policy_rate??'—'}%. Date is derived from the latest verified LIVE_PROVIDER official-rate snapshot; exact decision time is not stored.`,
   region_key:row.region_key,
   central_bank:row.central_bank||null,
   policy_rate:row.policy_rate==null?null:Number(row.policy_rate),
   observed_at:row.observed_at,
   is_active:true
  };
 }).filter(Boolean).sort((a,b)=>String(a.scheduled_at).localeCompare(String(b.scheduled_at))||String(a.region_key).localeCompare(String(b.region_key)));
}

export function mergeEconomicCalendar(stored=[],official=[]){
 const map=new Map();
 for(const row of [...(Array.isArray(stored)?stored:[]),...(Array.isArray(official)?official:[])]){
  const key=String(row?.event_key||row?.id||'');
  if(!key)continue;
  const existing=map.get(key);
  if(!existing||U(row?.verification_status)==='VERIFIED')map.set(key,row);
 }
 return[...map.values()].sort((a,b)=>String(a.scheduled_at||'').localeCompare(String(b.scheduled_at||'')));
}
